<!--
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-06-28 11:31:44
 * @LastEditTime: 2021-07-05 16:58:49
 * @Description: 
-->
<template>
  <div class="control-box">
    <el-divider content-position="left">关于系统</el-divider>
    <el-form label-width="120px">
      <div>
        <el-form-item label="版本号：">
          {{ form.system.version }}
        </el-form-item>
        <el-form-item label="PIN码：">
          <!-- <el-input v-model="form.system.pinNumber" /> -->
          {{ form.system.pinNumber }}
        </el-form-item>
        <el-form-item label="软件授权日期：">
          {{ form.system.authorizationData }}
        </el-form-item>
        <!-- <el-form-item label="导入授权文件">
          <el-upload
            ref="uploader"
            name="excel"
            with-credentials
            :accept="mime"
            :action="action"
            :show-file-list="false"
            :on-success="handleSuccess"
          >
            <el-button size="small" type="primary">导入授权文件</el-button>
          </el-upload>
        </el-form-item> -->
      </div>

      <!-- <el-form-item>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";
import UTIL from "@/api/sync/util";
import HOME from "@/api/sync/home";

export default {
  data() {
    return {
      form: null,
      current: "0",
      cards: [],
      offsets: [],
      managers: []
    };
  },
  computed: {
    ...mapState(["options", "schemas"]),
    label: () => card => card.$slots.header[0].children[0].children[0].text,
    mapAttrs: vm => filter =>
      vm.schemas
        ?.filter(filter)
        .map(schema => schema.attrs)
        .flat()
        .reduce(
          (arr, attr) =>
            arr.find(a => a.name === attr.name) ? arr : [...arr, attr],
          []
        ) ?? [],
    allAttrs: vm => vm.mapAttrs(() => true),
    userAttrs: vm => vm.mapAttrs(schema => schema.isUser),
    groupAttrs: vm => vm.mapAttrs(schema => schema.isGroup),
    containerAttrs: vm => vm.mapAttrs(schema => schema.isContainer)
  },
  async created() {
    // 等待Store初始化完成
    await this.$store.init;
    await this.getOptions();
    await this.getManagers();
    this.form = _.cloneDeep(this.options);
    this.form.netease.key = "";
  },
  updated() {
    if (this.$refs.form) {
      this.cards = this.$refs.form.$children;
      this.offsets = this.cards.map(c => c.$el.offsetTop - 20);
    }
  },
  methods: {
    async getOptions() {
      const response = await UTIL.OPTIONS();
      if (response.data.state) {
        await this.$store.dispatch("setOptions", response.data.options);
      }
    },
    async getManagers() {
      let response = await UTIL.MANAGERS();
      if (response.data.state) {
        this.managers = response.data.managers;
      }
    },
    async handleSave() {
      try {
        const subForm = _.cloneDeep(this.form);
        if (subForm.netease.key === "") {
          subForm.netease.key = this.options.netease.key;
        }
        let response = await HOME.SETTING(subForm);
        if (response.data.state) {
          await this.$store.dispatch("setOptions", subForm);
          this.$message.success("系统信息保存成功");
        } else {
          this.$message.error(response.data.message ?? "系统信息成功失败");
        }
        // eslint-disable-next-line no-empty
      } catch {}
    }
  }
};
</script>

<style lang="less" scoped>
.control-box {
  height: 100%;
  padding: 0 10px;
  overflow: auto;
  width: 600px;
}
.el-divider {
  margin: 30px 0;
  .el-divider__text {
    color: #1f8fff;
    font-weight: bold;
  }
}
.el-form {
  ::v-deep * {
    font-size: 13px;
  }
  label.label-red {
    color: #ff9e00;
    margin-left: 6px;
  }
}
</style>
